import React from 'react';
import { Box, Typography } from '@mui/material';
import { useTranslatedDictionary } from './hooks/useTranslatedDictionary';

const ABOUT_FOOTER_TEXT = {
  es: {
    rightsReserved: 'Todos los derechos reservados.',
  },
  en: {
    rightsReserved: 'All rights reserved.',
  },
};

export default function AboutFooter({ sx = {}, isLightTheme = false, language = 'es' }) {
  const t = useTranslatedDictionary(ABOUT_FOOTER_TEXT, language);
  const muted = isLightTheme ? 'rgba(15,20,32,0.4)' : 'rgba(255,255,255,0.35)';
  return (
    <Box sx={{ textAlign: 'center', pt: 4, pb: 2, ...sx }}>
      <Box
        component="img"
        src="/logo192.png"
        alt="Gexvi"
        sx={{ width: 36, height: 36, borderRadius: '10px', mb: 1.2 }}
      />
      <Typography sx={{ color: isLightTheme ? '#0f1420' : '#fff', fontWeight: 700, fontSize: '0.9rem' }}>
        Gexvi
      </Typography>
      <Typography
        sx={{
          color: muted,
          fontSize: '0.7rem',
          fontFamily: 'monospace',
          mt: 0.3,
          mb: 1.2,
        }}
      >
        v1.0.0
      </Typography>
      <Typography
        sx={{
          color: muted,
          fontSize: '0.7rem',
          lineHeight: 1.6,
          maxWidth: 240,
          mx: 'auto',
        }}
      >
        © 2026 Dapur Tecnología.<br />{t('rightsReserved')}
      </Typography>
    </Box>
  );
}
